import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 20px;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const Header = styled.div`
    display: flex;
`;

export const BackArrowIcon = styled.div`
    display: flex;
    cursor: pointer;
`;

export const ContactUsTitle = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
    margin-top: 20px;
`;

export const Text = styled.div`
    display: flex;
    margin-top: 20px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
    margin-bottom: 20px;
`;

export const ContactFlex = styled.div`
    display: flex;
    margin: 20px 0;
`;

export const Label = styled.div`
    display: flex;
    flex: 1;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
`;

export const Value = styled.div`
    display: flex;
    flex: 3;
    justify-content: flex-end;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: #1b73e8;
`;

export const Hr = styled.div`
    width: 100%;
    border: 1px solid #e7e7f0;
`;
